<template>
	<div>
		<div style="float:right;margin-top:5px" v-if="syncCount!=0">
			<div class="spinner-border" style></div>
			<span style="color:red">Data is syncing</span>
		</div>
			<table class="table" style="table-layout:fixed; z-index: 2">
				<thead style="position: sticky; z-index:2">
					<tr>
						<th style="width: 15%;" class="link" v-on:click="sorting('client_name',$event)">
							Client Name
							<i
								class="sort fa"
								:class="sort.field=='client_name'? sort.order =='asc' ? 'fa-arrow-up':'fa-arrow-down':''"
							></i>
						</th>
						<th style="width:10%; text-align: center;">
							Brand Tag Alignment
							<i class="fa fa-info-circle testtooltip" style="cursor: pointer;" >
								<div class="tooltiptext">
									<div>This icon represents alignment across tags for Products, Campaigns, Orders</div>
									<div>Green means your aligned tags are 80% or more aligned out of all of your brand tags</div>
									<div>Orange means your aligned tags are between 40-79% aligned out of all of your brand tags</div>
									<div>Red means your aligned tags are less than 20% aligned out of your brand tags</div>
								</div>
							</i>
						</th>
						<th style="width:10%; text-align: center;">
							Category Tag Alignment
							<i class="fa fa-info-circle testtooltip" style="cursor: pointer;" >
								<div class="tooltiptext">
									<div>This icon represents alignment across tags for Products, Campaigns, Orders</div>
									<div>Green means your aligned tags are 80% or more aligned out of all of your category tags</div>
									<div>Orange means your aligned tags are between 40-79% aligned out of all of your category tags</div>
									<div>Red means your aligned tags are less than 20% aligned out of your category tags</div>
								</div>
							</i>
						</th>
						<th style="width:10%; text-align: center;">
							Sub-Category Tag Alignment
							<i class="fa fa-info-circle testtooltip" style="cursor: pointer;" >
								<div class="tooltiptext">
									<div>This icon represents alignment across tags for Products, Campaigns, Orders</div>
									<div>Green means your aligned tags are 80% or more aligned out of all of your sub-category tags</div>
									<div>Orange means your aligned tags are between 40-79% aligned out of all of your sub-category tags</div>
									<div>Red means your aligned tags are less than 20% aligned out of your sub-category tags</div>
								</div>
							</i>
						</th>
						<th style="width:15%; text-align: center;" data-toggle="tooltip">
							Fully Tagged Products 
							<i class="fa fa-info-circle testtooltip" style="cursor: pointer;" >
								<div class="tooltiptext">
									<div>Percentage of products with all 3 strategic tag types completed (brand, category, sub-category)</div>
								</div>
							</i>
						</th>
						<th style="width:15%; text-align: center;" data-toggle="tooltip">
							Fully Tagged Campaigns
							<i class="fa fa-info-circle testtooltip" style="cursor: pointer;" >
								<div class="tooltiptext">
									<div>Percentage of campaigns with all 3 strategic tag types completed (brand, category, sub-category)</div>
								</div>
							</i>
						</th>
						<th style="width:15%; text-align: center;" data-toggle="tooltip">
							Fully Tagged Orders
							<i class="fa fa-info-circle testtooltip" style="cursor: pointer;" >
								<div class="tooltiptext">
									<div>Percentage of orders with all 3 strategic tag types completed (brand, category, sub-category)</div>
								</div>
							</i>
						</th>
						<th style="width:10%; text-align: center;" class="link" v-on:click="sorting('date_created',$event)">
							Created On
							<i
								class="sort fa"
								:class="sort.field=='date_created'? sort.order =='asc' ? 'fa-arrow-up':'fa-arrow-down':''"
							></i>
						</th>
						<th></th>
					</tr>
				</thead>
				<tbody>
					<template
						v-for="(item, index) in accountsList"
						:key="item.profile_id + '_'+ item.ams_profile_id+'_'+ index"
						:class="index%2==0?'even':''"
					>
						<tr
							:class="index%2==0?'even':''"
						>
							<td style="word-break:break-all; vertical-align: middle !important; text-align: left;" >
								<a href="javascript:void(0)" 
								@click="viewMore(item)" 
								style="color: #143A33;word-break: break-word;">
									<i :class="item.viewMore ? 'fa fa-chevron-down' : 'fa fa-chevron-right'"></i>
									{{item.client_name}}
								</a>
							</td>
							<td style="vertical-align: middle !important; text-align: center !important;">
								<div
									:style="{display: 'inline-block', width: '20px', 'border-radius': '10px', height: '20px', 'background-color': color(item, ['campaign_brand','brand_product','brand'])}"
								></div>
							</td>
							<td style="vertical-align: middle !important; text-align: center !important;">
								<div
									:style="{display: 'inline-block', width: '20px', 'border-radius': '10px', height: '20px', 'background-color': color(item, ['campaign_category','category_product','product_category'])}"
								></div>
							</td>
							<td style="vertical-align: middle !important; text-align: center !important;">
								<div
									:style="{display: 'inline-block', width: '20px', 'border-radius': '10px', height: '20px', 'background-color': color(item, ['campaign_subcategory','sub_category_product','subcategory'])}"
								></div>
							</td>
							<td style="vertical-align: middle !important; text-align: center !important;">
								<div class="row" style="display: inline-block;" v-if="item.vendor_prod_count || item.seller_prod_count">
									<div class="col-md-3 col-sm-6" style="cursor: pointer;" @click="navigateToProduct(item)">
										<div class="progress blue">
											<span class="progress-left">
											<span class="progress-bar" :style="{'--coverage-2': calculateCircle2Deg(calculateCoverage([item.client_tagged_vp, item.client_tagged_sp], [item.vendor_prod_count, item.seller_prod_count]))}"></span>
											</span>
											<span class="progress-right">
												<span class="progress-bar" :style="{'--coverage-1': calculateCircle1Deg(calculateCoverage([item.client_tagged_vp, item.client_tagged_sp], [item.vendor_prod_count, item.seller_prod_count]))}"></span>
											</span>
											<div class="progress-value">{{calculateCoverage([item.client_tagged_vp, item.client_tagged_sp], [item.vendor_prod_count, item.seller_prod_count])}}%</div>
										</div>
									</div>
								</div>
								<div v-else>N/A</div>
							</td>
							<td style="vertical-align: middle !important; text-align: center !important;">
								<div class="row" style="display: inline-block;" v-if="item.client_camp_count">
									<div class="col-md-3 col-sm-6" style="cursor: pointer;" @click="navigateToCampaign(item)">
										<div class="progress blue" >
											<span class="progress-left">
											<span class="progress-bar" :style="{'--coverage-2': calculateCircle2Deg(calculateCoverage([item.client_tagged_camp_count], [item.client_camp_count]))}"></span>
											</span>
											<span class="progress-right">
												<span class="progress-bar" :style="{'--coverage-1': calculateCircle1Deg(calculateCoverage([item.client_tagged_camp_count], [item.client_camp_count]))}"></span>
											</span>
											<div class="progress-value">{{calculateCoverage([item.client_tagged_camp_count], [item.client_camp_count])}}%</div>
										</div>
									</div>
								</div>
								<div v-else>N/A</div>
							</td>
							<td style="vertical-align: middle !important; text-align: center !important;">
								<div class="row" style="display: inline-block;" v-if="item.dsp_count">
									<div class="col-md-3 col-sm-6" style="cursor: pointer;" @click="navigateToDSP(item)">
										<div class="progress blue">
											<span class="progress-left">
											<span class="progress-bar" :style="{'--coverage-2': calculateCircle2Deg(calculateCoverage([item.client_tagged_dsp],[item.dsp_count]))}"></span>
											</span>
											<span class="progress-right">
												<span class="progress-bar" :style="{'--coverage-1': calculateCircle1Deg(calculateCoverage([item.client_tagged_dsp], [item.dsp_count]))}"></span>
											</span>
											<div class="progress-value">{{calculateCoverage([item.client_tagged_dsp], [item.dsp_count])}}%</div>
										</div>
									</div>
								</div>
								<div v-else>N/A</div>
							</td>
							<td style="vertical-align: middle !important; text-align: center !important;">{{ShowCreatedOn(item.created_on)}}</td>
							<td style="vertical-align: middle !important;" class="row-add-edit">
								<div class="row-add-edit">
									<a href="javascript:void(0)" class="item-add-edit" data-toggle="dropdown"></a>
									<div
										class="dropdown-menu"
										aria-labelledby="dropdownMenuButton"
										style="left:-58px"
										
									>
										<a class="grid-item ico-edit remove-padding" @click="viewDetails(item)" v-if="item.is_active">Edit Tag Definitions</a>
									</div>
								</div>
							</td>
						</tr>
						<tr :class="index%2==0?'even':''" v-if="item.viewMore">
							<td colspan="4"></td>
							<td v-if="item.seller_prod_count || item.vendor_prod_count" style="vertical-align: top  !important; text-align: center !important; font-size: small;"> 
								{{+item.client_tagged_vp + +item.client_tagged_sp}}/{{ +item.seller_prod_count + +item.vendor_prod_count }}
							</td>
							<td v-else colspan="1"></td>
							<td v-if="item.client_camp_count" style="vertical-align: top !important; text-align: center !important; font-size: small;">
								{{item.client_tagged_camp_count}}/{{ item.client_camp_count }}
							</td>
							<td v-else colspan="1"></td>
							<td v-if="item.dsp_count" style="vertical-align: top; text-align: center !important; font-size: small;">
								{{item.client_tagged_dsp}}/{{ item.dsp_count }}
							</td>
							<td v-else colspan="1"></td>
							<td colspan="2"></td>
						</tr>
						<tr :class="index%2==0?'even':''" v-if="item.viewMore">
							<td colspan="1" style="font-weight: bold; text-align: left;"> 
								Brand
							</td>
							<td colspan="2" style="font-weight: bold; text-align: left;"> 
								Category
							</td>
							<td colspan="3" style="font-weight: bold; text-align: left;"> 
								Sub-Category
							</td>
							<td colspan="3" style="font-weight: bold; text-align: left;">
								Tag Definitions
							</td>
							<td colspan="1"></td>
						</tr>
						<tr :class="index%2==0?'even':''" v-if="item.viewMore">
							<td colspan="1" style="column-count: 2;">
								<div class="label label-info tag_label brand"
								:title="'Brand (' + tag.types.join(', ') + '): ' + tag.title"
								v-for="tag of 
								[
									...formatTags(item, ['campaign_brand','brand_product','brand'], 'Brand').sort((a,b) => {b.types.length - a.types.length})
								].sort((a,b) => b.types.length - a.types.length)">
									{{`${tag.types.length === 3 ? ' ✓ ': ''}[${tag.types.join(', ')}] ${tag.title}`}}
								</div>
							</td>
							<td colspan="2" style="column-count: 2;">
								<div class="label label-info tag_label cat"
								:title="'Category (' + tag.types.join(', ') + '): ' + tag.title"
								v-for="tag of 
								[
									...formatTags(item, ['campaign_category','category_product','product_category'], 'Category')
								].sort((a,b) => b.types.length - a.types.length)">
									{{`${tag.types.length === 3 ? ' ✓ ': ''}[${tag.types.join(', ')}] ${tag.title}`}}
								</div>
							</td>
							<td colspan="3" style="column-count: 4;">
								<div class="label label-info tag_label subcat"
								:title="'Sub-Category (' + tag.types.join(', ') + '): ' + tag.title"
								v-for="tag of 
								[
								...formatTags(item, ['campaign_subcategory','sub_category_product','subcategory'], 'Sub-Cat').sort((a,b) => {a.types.length - b.types.length})
								].sort((a,b) => b.types.length - a.types.length)">
									{{`${tag.types.length === 3 ? ' ✓ ': ''}[${tag.types.join(', ')}] ${tag.title}`}}
								</div>
							</td>
							<td colspan="2">
								<div v-if="(item.tags_strategy || []).filter(t => t.type === 'brand_def').length">
									<span style="color: #2F5BC2; font-weight: bold;">Brand: </span><span>{{item.tags_strategy.filter(t => t.type === 'brand_def').map(t => t.title).join(',')}}</span>
								</div>
								<div v-if="(item.tags_strategy || []).filter(t => t.type === 'category_def').length">
									<span style="color: #1C919E; font-weight: bold;">Category:</span><span>{{item.tags_strategy.filter(t => t.type === 'category_def').map(t => t.title).join(',')}}</span>
								</div>
								<div v-if="(item.tags_strategy || []).filter(t => t.type === 'subcategory_def').length">
									<span style="color: #D98F34; font-weight: bold;">Sub-Category:</span><span>{{item.tags_strategy.filter(t => t.type === 'subcategory_def').map(t => t.title).join(',')}}</span>
								</div>						
							</td>
							<td colspan="1"></td>
						</tr>
					</template>
				</tbody>
			</table>
		<ListNamesPopUp
			ref="listPopUp"
			:namesArray="listItems"
			:type="listType"
			:clientName="clientName"
			:showSpinner="fetchingItem"
		/>
	</div>
</template>

<script>
	import moment from "moment";
	import ListNamesPopUp from "@/components/account-management/ListNamesPopUp";

	export default {
		name: "TaggingListGrid",
		props: ["isExportExcel"],
		data() {
			return {
				listItems: [],
				listType: "",
				clientName: "",
				fetchingItem: false,
				delClientId:null,
				delClientName:'',
				set_client_active : null,
				isUserAdmin: this.$store.state.isUserAdmin,
				productCoverage: 75,
				sponsoredAdsCoverage: 50,
				dspCoverage: 33
			};
		},
		components: {
			ListNamesPopUp,
			moment,
		},
		watch: {},
		computed: {
			popupTitle:{
				get(item){
					return `Are you sure, you want to ${this.set_client_active ?  'Enable':'Disable'} this client?`
				}
			},
			sort: {
				set(val) {
					this.$store.commit("setSelectedSortOrder", val);
				},
				get() {
					return this.$store.state.selectedSortOrder;
				}
			},
			accountsList: {
				set(val) {
					this.$store.commit("accounts/updateAccountList", val);
				},
				get() {
					return this.$store.getters["accounts/getAccountList"];
				}
			},
			syncCount: {
				get() {
					return this.$store.getters["accounts/getSyncCount"];
				}
			}
		},
		mounted() {},
		methods: {
			navigateToDSP(item) {
				this.$router.push({path:'/dspTagList'})
			},
			navigateToProduct(item) {
				this.$router.push({path:'/productList'})
			},
			navigateToCampaign(item) {
				this.$router.push({path:'/campaignList'})
			},
			viewMore(item) {
				item.viewMore = item.viewMore ? false : true
			},
			tooltipCode() {
				$(document).ready(function () {
					$('[data-toggle="tooltip"]').tooltip();
				});
			},
			calculateCoverage(num, div) {
				num = num.map(a => !a ? 0 : parseInt(a)).reduce((a,b) => a+b)

				div = div.map(a => !a ? 0 : parseInt(a)).reduce((a,b) => a+b)

				return Math.floor(100*num/div)
			},
			calculateCircle1Deg(coverage){
				let degrees = `${coverage*3.6}deg`
				if (coverage > 50) {
					return '180deg'
				}
				return degrees
			},
			calculateCircle2Deg(coverage){
				let degrees = '0deg'
				if (coverage > 50) {
					degrees = `${coverage*3.6 - 180}deg`
				}
				return degrees
			},
			formatTags(accountData, filter, type){
				// const allTags = [...(accountData.tags_dsp || []), ...(accountData.tags_vendor || []), ...(accountData.tags_seller || []), ...(accountData.tags_campaign || [])]

				const tagMap = {}
				for (const tag of (accountData.tags_dsp || []).filter(t => filter.includes(t.type))){
					tag.title = tag.title.trim()
					tagMap[tag.title] = tagMap[tag.title] ?  tagMap[tag.title].concat(['DSP']) : ['DSP']
				}
				for (const tag of (accountData.tags_vendor || []).filter(t => filter.includes(t.type))){
					tag.title = tag.title.trim()
					tagMap[tag.title] = tagMap[tag.title] ?  tagMap[tag.title].concat(['P']) : ['P']
				}
				for (const tag of (accountData.tags_seller || []).filter(t => filter.includes(t.type))){
					tag.title = tag.title.trim()
					tagMap[tag.title] = tagMap[tag.title] ?  tagMap[tag.title].concat(['P']) : ['P']
				}
				for (const tag of (accountData.tags_campaign || []).filter(t => filter.includes(t.type))){
					tag.title = tag.title.trim()
					tagMap[tag.title] = tagMap[tag.title] ?  tagMap[tag.title].concat(['SA']) : ['SA']
				}

				const tagsArray = []
				for (const key in tagMap){
					// tagsArray.push(`${key} (${[...new Set(tagMap[key])].join(', ')})`)
					tagsArray.push({title: key, types:[...new Set(tagMap[key])]})
				}

				return tagsArray
			},
			sorting(field, event) {
				if (
					event.currentTarget.children[0].classList[2] == "fa-arrow-up" ||
					event.currentTarget.children[0].classList[2] == "fa-arrow-down"
				) {
					var pastEvent = true;
				}
				for (
					var i = 0;
					i < document.getElementsByClassName("sort").length;
					i++
				) {
					document
						.getElementsByClassName("sort")
						[i].classList.remove("fa-arrow-up");
					document
						.getElementsByClassName("sort")
						[i].classList.remove("fa-arrow-down");
				}
				if (pastEvent) {
					this.sort.order == "desc"
						? event.currentTarget.children[0].classList.add(
								"fa-arrow-up"
						  )
						: event.currentTarget.children[0].classList.add(
								"fa-arrow-down"
						  );
					pastEvent = false;
				} else {
					event.currentTarget.children[0].classList.add("fa-arrow-up");
				}

				this.sort = {
					field: field,
					order:
						event.currentTarget.children[0].classList[2] ==
						"fa-arrow-up"
							? "asc"
							: "desc"
				};

				// this.$store.state.sort.field = field;
				// this.$store.state.sort.order = (event.currentTarget.children[0].classList[2]) == 'fa-angle-up' ? 'asc':'desc';
			},
			ShowCreatedOn(data) {
				return moment(data).format("MM/DD/YYYY");
			},
			getCampType(item) {
				var arr = [];
				if (item.marketing_campaign_sb) {
					arr.push("SB");
				}
				if (item.marketing_campaign_sp) {
					arr.push("SP");
				}
				if (item.marketing_campaign_sd) {
					arr.push("SD");
				}
				return arr.join(", ");
			},
			viewDetails(item) {
				//let vendorId = item.go_vendor_cd ? item.go_vendor_cd : null;
				if (item.client_id && this.$route.path === '/taggingStrategy') {
					this.$router.push({
						path: "/taggingStrategy" + "/" + item.client_id + '/' + btoa(item.client_name)
					});
				}
			},
			color(item, tagTypes) {
				let total = 0
				let tagTitleCounts = {}
				if ( item.seller_prod_count) { 
					++total 
					for (const tag of (item.tags_seller || []).filter(t => tagTypes.includes(t.type))) {
						tagTitleCounts[tag.title] = 1 + (tagTitleCounts[tag.title] || 0)
					}
				}
				if (item.vendor_prod_count) { 
					++total
					for (const tag of (item.tags_vendor || []).filter(t => tagTypes.includes(t.type))) {
						tagTitleCounts[tag.title] = 1 + (tagTitleCounts[tag.title] || 0)
					}
				}
				if ( item.dsp_count) { 
					++total
					for (const tag of (item.tags_dsp || []).filter(t => tagTypes.includes(t.type))) {
						tagTitleCounts[tag.title] = 1 + (tagTitleCounts[tag.title] || 0)
					}
				}
				if (item.client_camp_count) { 
					++total
					for (const tag of (item.tags_campaign || []).filter(t => tagTypes.includes(t.type))) {
						tagTitleCounts[tag.title] = 1 + (tagTitleCounts[tag.title] || 0)
					}
				}

				let aligned = 0
				for (const key in tagTitleCounts) {
					// console.log(tagTitleCounts[key])
					if (tagTitleCounts[key] == total) {
						aligned = aligned + 1
					}
				}

				const uniqueTagTitleCount = Object.keys(tagTitleCounts).length

				let color = 'grey'
				if (total && (aligned*100/uniqueTagTitleCount > 80)) {
					color = 'green'
				} else if (total && (aligned*100/uniqueTagTitleCount >= 20)) {
					color = 'orange'
				} else if (total) {
					color = '#d10b4f'
				} 

				// if (item.client_name === 'Prime Day Client') {
				// 	console.log('TAG TITLE COUNTS - (total: ', total, ', aligned: ', aligned ,') - ,', item.client_name, ' : ', tagTitleCounts)
				// }


				// console.log('total: ', total, 'aligned: ', aligned)

				return color
			},
		}
	};
</script>

<style lang="scss">
/* Tooltip container */
.testtooltip {
  position: relative;
  display: inline-block;
//   border-bottom: 1px dotted black; /* If you want dots under the hoverable text */
}

/* Tooltip text */
.testtooltip .tooltiptext {
  visibility: hidden;
  width: 240px;
  background-color: black;
  color: #fff;
  font-weight: lighter;
  font-size: small;
  font-family: Roboto;
  text-align: center;
  padding: 5px 5px;
  border-radius: 6px;
 
  /* Position the tooltip text - see examples below! */
  position: absolute;
  z-index: 1;
}

/* Show the tooltip text when you mouse over the tooltip container */
.testtooltip:hover .tooltiptext {
  visibility: visible;
}
.show_green {
	background-color: green;
}
.show_red {
	background-color: red;
}
.remove-padding{
	padding-top: 0px !important;
	padding-bottom: 0px !important;
}
.tag_label{
	display: block !important; 
	padding: 5px !important; 
	margin: 2px !important; 
	// max-width:calc(100%) !important; 
	width: 100%;
	text-overflow: ellipsis !important; 
	white-space: nowrap !important; 
	overflow: hidden !important;
}
.brand{
	background-color: #2F5BC2 !important;
}
.cat{
	background-color: #1C919E !important;
}
.subcat{
	background-color: #D98F34 !important;
}

.progress{
    width: 50px;
    height: 50px;
    line-height: 100px;
    background: none;
    margin: 0 auto;
    box-shadow: none;
    position: relative;
}
.progress:after{
    content: "";
    width: 100%;
    height: 100%;
    border-radius: 50%;
    border: 6px solid #f0f0f0;
    position: absolute;
    top: 0;
    left: 0;
}
.progress > span{
    width: 50%;
    height: 100%;
    overflow: hidden;
    position: absolute;
    top: 0;
    z-index: 1;
}
.progress .progress-left{
    left: 0;
}
.progress .progress-bar{
    width: 100%;
    height: 100%;
    background: none;
    border-width: 6px;
    border-style: solid;
    position: absolute;
    top: 0;
}
.progress .progress-left .progress-bar{
    left: 100%;
    border-top-right-radius: 80px;
    border-bottom-right-radius: 80px;
    border-left: 0;
    -webkit-transform-origin: center left;
    transform-origin: center left;
}
.progress .progress-right{
    right: 0;
}
.progress .progress-right .progress-bar{
    left: -100%;
    border-top-left-radius: 80px;
    border-bottom-left-radius: 80px;
    border-right: 0;
    -webkit-transform-origin: center right;
    transform-origin: center right;
	// -webkit-transform: rotate(var(--coverage));
	// transform: rotate(var(--coverage));
    animation: loading-1 1.8s linear forwards; 
}
.progress .progress-value{
    width: 90%;
    height: 90%;
    border-radius: 50%;
    // background: #ffffff;
	background: none;
    font-size: 12px;
    // color: rgb(17, 94, 103);
    line-height: 50px;
    text-align: center;
    position: absolute;
    top: 5%;
    left: 5%;
}
.progress.blue .progress-bar{
    border-color: rgb(17, 94, 103);
}
.progress.blue .progress-left .progress-bar{
    animation: loading-2 1.5s linear forwards 1.8s;
}


@keyframes loading-1{
    0%{
        -webkit-transform: rotate(0deg);
        transform: rotate(0deg);
    }
    100%{
        -webkit-transform: rotate(var(--coverage-1));
        transform: rotate(var(--coverage-1));
    }
}
@keyframes loading-2{
    0%{
        -webkit-transform: rotate(0deg);
        transform: rotate(0deg);
    }
    100%{
        -webkit-transform: rotate(var(--coverage-2));
        transform: rotate(var(--coverage-2));
    }
}
@media only screen and (max-width: 990px){
    .progress{ margin-bottom: 20px; }
}

</style>
